/**
* Created by vouill on 3/14/18.
*/

<template>
  <div class="main">
    <div class="container">
      <div class="v-title">
        <div>Qui sommes nous ?</div>
      </div>
      <div class="text">{{ text }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main {
  background-color: white;
  display: flex;
  justify-content: center;
  padding: 8vh 10% 10vh 10%;
}

.container {
  text-align: center;
  background-color: white;
  max-width: 900px;
}

.v-title {
  font-size: 26px;
  font-weight: bold;
  color: #ef6c00;
  font-family: "Roboto Slab", serif;
  div {
    padding-bottom: 1em;
  }
}
.text {
  font-size: 18px;
  /*font-weight: 600;*/
  letter-spacing: 1px;
}
</style>

<script>
export default {
  name: "WhoAreWe",
  props: { data: Object },
  components: {},
  computed: {
    text: function() {
      const { data } = this;
      return data && data.items[0].fields.whoAreWe;
    }
  }
};
</script>
